import React, { useState, useEffect, useRef } from "react";
import { BsRobot } from "react-icons/bs";

const ChatWithUs = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [welcomeShown, setWelcomeShown] = useState(false);
  const [typing, setTyping] = useState(false);

  const audioRef = useRef(new Audio("/assets/sendSound.mp3"));
  const chatEndRef = useRef(null);

  // 🔊 Play sound
  const playSound = () => {
    audioRef.current.currentTime = 0;
    audioRef.current.play();
  };

  // ✅ BOT RESPONSES
  const botResponses = {
    hi: "👋 Hi! Welcome to Transaction Analysts. How can I help you today?",
    help: "Sure 🙂 Please tell me your issue. I’ll help you or guide you to support.",
    payment_issue: "🔎 Please share your Transaction ID. We’ll check your payment status.",
    refund_status: "💸 Refunds usually take 5–7 working days. If delayed, please share details.",
    wallet_info: "📱 TA Wallet helps you recharge, pay bills, and transfer money easily.",
    bill_payment: "⚡ You can pay electricity, gas, DTH and more using our services.",
    aeps: "🏦 AePS lets you withdraw cash using Aadhaar and fingerprint—no ATM card needed.",
    merchant: "🧾 Want to become a merchant? We provide easy onboarding solutions.",
    api: "💻 Yes, we provide API integrations. You can test using our sandbox.",
    contact: "📧 Contact us at support@taipl.in or call +91 80 26784479.",
    location: "📍 Our head office is in Bengaluru and we also operate from Hyderabad.",
    default: "🤖 I’m sorry, I couldn’t understand your request. Please contact our support center at 8919056119 for assistance."
  };

  // ✅ FIXED SMART MATCHING
  const getBotReply = (text) => {
    const msg = text.toLowerCase().trim();

    if (msg.includes("hi") || msg.includes("hello"))
      return botResponses.hi;

    if (msg.includes("help") || msg.includes("support"))
      return botResponses.help;

    if (
      msg.includes("payment") ||
      msg.includes("failed") ||
      msg.includes("transaction")
    )
      return botResponses.payment_issue;

    if (msg.includes("refund"))
      return botResponses.refund_status;

    if (msg.includes("wallet"))
      return botResponses.wallet_info;

    if (
      msg.includes("bill") ||
      msg.includes("bills") ||
      msg.includes("electricity") ||
      msg.includes("dth")
    )
      return botResponses.bill_payment;

    if (msg.includes("aeps") || msg.includes("aadhaar"))
      return botResponses.aeps;

    if (msg.includes("merchant"))
      return botResponses.merchant;

    if (msg.includes("api") || msg.includes("integration"))
      return botResponses.api;

    if (
      msg.includes("contact") ||
      msg.includes("email") ||
      msg.includes("phone")
    )
      return botResponses.contact;

    if (msg.includes("location") || msg.includes("address"))
      return botResponses.location;

    return botResponses.default;
  };

  // 📩 Send Message
  const sendMessage = (text = input) => {
    if (!text.trim()) return;

    const userMsg = { text, sender: "user" };
    const reply = getBotReply(text);

    setMessages((prev) => [...prev, userMsg]);
    setInput("");
    setTyping(true);

    setTimeout(() => {
      const botMsg = { text: reply, sender: "bot" };
      setMessages((prev) => [...prev, botMsg]);
      setTyping(false);
      playSound();
    }, 800);
  };

  // 👋 Welcome Message
  useEffect(() => {
    if (open && !welcomeShown) {
      const welcomeMsg = {
        text: "👋 Welcome to Transaction Analysts! How can I help you today?",
        sender: "bot",
      };
      setMessages((prev) => [...prev, welcomeMsg]);
      setWelcomeShown(true);
    }
  }, [open, welcomeShown]);

  // ⬇ Auto Scroll
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  // ✅ FIXED FAQ BUTTONS
  const faqKeywords = [
    "Hi",
    "Help",
    "Payment",
    "Refund",
    "Wallet",
    "Bill",
    "AePS",
    "Merchant",
    "API",
    "Contact",
    "Location"
  ];

  return (
    <div className={`chat-float ${open ? "open bounce-in-left" : ""}`}>
      <div className="chat-box">
        <div className="chat-header">
          <span>Chat with Us</span>
          <button onClick={() => setOpen(false)}>✕</button>
        </div>

        <div className="chat-body">
          {messages.map((msg, i) => (
            <div key={i} className={`chat-msg ${msg.sender}`}>
              {msg.text}
            </div>
          ))}

          {typing && (
            <div className="chat-msg bot typing-indicator">
              <div className="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}

          <div ref={chatEndRef} />
        </div>

        <div className="faq-buttons">
          {faqKeywords.map((key) => (
            <button key={key} onClick={() => sendMessage(key)}>
              {key}
            </button>
          ))}
        </div>

        <div className="chat-input">
          <input
            type="text"
            placeholder="Type your message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button onClick={() => sendMessage()}>➡️</button>
        </div>
      </div>

      {!open && (
        <button
          className="chat-toggle bounce-in-up"
          onClick={() => setOpen(true)}
        >
          <BsRobot style={{ marginRight: "8px", height: "30px", width: "20px" }} />
          Chat with Us
        </button>
      )}
    </div>
  );
};

export default ChatWithUs;